<template>
  <div class="card-area">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">Step 2 of 4</div>
        </md-card-header>
        <div class="md-title">
          We have sent you a 6 digit code to your cell phone.
        </div>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field>
                <label for="six-digit">Six Digit Code</label>
                <md-input
                  name="six-digit"
                  id="six-digit"
                  autocomplete="given-name"
                  v-model="form.sixcode"
                />
                <span class="md-error" v-if="!$v.form.sixcode.required"
                  >The last name is required</span
                >
                <span class="md-error" v-else-if="!$v.form.sixcode.minlength"
                  >Invalid last name</span
                >
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <md-button class="md-primary" @click="Gophoto">Next</md-button>
        </md-card-actions>
        <div class="footer">
          Didn't Recive a code?
          <a href="http://localhost:8080/ResendCode"><u>Resent</u></a> <br />
          <a href="http://localhost:8080/SendCode"><u>Try With Email</u></a>
        </div>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "SendCode",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    form: {
      sixcode: null,
    },
  }),
  validations: {
    form: {
      sixcode: {
        required,
        minLength: minLength(3),
      },
    },
  },
  mounted() {},
  methods: {
    Gophoto() {
      this.$router.push({ name: "TakePhotoPrepare" });
    },
    saveUser() {},
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.md-card-actions {
  flex-direction: column;
}

.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}

.footer {
  margin-top: 20px;
  padding: 10px;
  font-size: 120%;
}

.md-card {
  display: inline-block;
  padding: 20px;
}

.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}

.md-primary {
  background-color: green;
  color: white !important;
}

.md-layout-item.md-size-50 {
  min-width: 80%;
  max-width: 70%;
} */
</style>
